import { Directive, HostListener, inject, input, OnInit } from '@angular/core';
import { CORE_USER_ACTIVITY_SECTION, ScreenTrackingService, UserActivityService } from '../services';
import { combineLatest } from 'rxjs';

@Directive({
  selector: '[coreUserActivityClickTracking]',
  standalone: true,
})
export class UserActivityClickTrackingDirective implements OnInit {

  private readonly sectionSubject = inject(CORE_USER_ACTIVITY_SECTION);
  private readonly screenTracking = inject(ScreenTrackingService);
  private readonly clickTracking = inject(UserActivityService);

  public readonly target = input.required<string>({
    alias: 'coreUserActivityClickTracking',
  });

  private section = '';
  private screen = '';

  public ngOnInit(): void {
    combineLatest([
      this.sectionSubject,
      this.screenTracking.screen$,
    ]).subscribe(([section, screen]) => {
      this.section = section;
      this.screen = screen;
    });
  }

  @HostListener('click', ['$event'])
  public clickEvent(event: MouseEvent): void {
    event.preventDefault();
    this.clickTracking.trackClick(event, this.screen, this.section, this.target());
  }

}
